'use client';

import { useTranslations } from '@/hooks/useTranslations';
import { RECURRING_FREQUENCIES } from '@/lib/constants/recurring';
import type { RecurringFrequency } from '@/lib/constants/recurring';

const SELECT_CLASS =
  'flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-xs transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50';

interface RecurringFrequencySelectProps {
  value: RecurringFrequency;
  onChange: (value: RecurringFrequency) => void;
  disabled?: boolean;
}

const FREQUENCY_KEYS: Record<RecurringFrequency, string> = {
  WEEKLY: 'frequency.weekly',
  MONTHLY: 'frequency.monthly',
  QUARTERLY: 'frequency.quarterly',
  ANNUALLY: 'frequency.annually',
};

export function RecurringFrequencySelect({
  value,
  onChange,
  disabled,
}: RecurringFrequencySelectProps) {
  const t = useTranslations('CreateInvoicePopup');

  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value as RecurringFrequency)}
      disabled={disabled}
      className={SELECT_CLASS}
    >
      {RECURRING_FREQUENCIES.map((freq) => (
        <option key={freq} value={freq}>
          {t(FREQUENCY_KEYS[freq])}
        </option>
      ))}
    </select>
  );
}
